import React, { Component } from 'react';

export default class Loading extends Component {
  render() {
    return (
      <div>
        <h4>
          Carregando...
        </h4>
      </div>
    );
  }
}
